module.exports = __webpack_public_path__ + "img/filter_list.73bd5ec7.svg";